const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/objectives/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import i18n from '@/common/translations/i18n';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
import { objectiveIdSearchParam } from '@/features/objectives/searchSchema';
const objectivesSearchSchema = itemPanelSearchSchema.extend({
  objectiveId: objectiveIdSearchParam,
  jumpToObjectiveId: objectiveIdSearchParam
});
export const Route = createFileRoute('/(app)/org/$org/objectives/')({
  staticData: {
    hideChrome: true,
    topNav: {
      title: i18n.t($ => $.objectives.page.title)
    }
  },
  validateSearch: zodValidator(objectivesSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});